<template>
  <div id="app"  v-cloak>
    <router-view class="main-content"/>
  </div>
</template>
<script>
export default {
  data () {
    console.log(window);
    return {
      innerWidth: window.innerWidth
    }
  },
  mounted () {
    // // 检测断网
    // window.addEventListener('offline', () => {
    //   this.$message.error('网络异常')
    // })
    // 是否清空缓存（只执行一次）
    if (window.g.clearCache && !sessionStorage.getItem('cacheCleared')) {
      localStorage.clear()
      sessionStorage.setItem('cacheCleared', 'true')
    }
  }

}
</script>
<style lang="scss">
.main-content {
  word-break: break-all;
}
[v-cloak] {
  display: none !important;
}
</style>
